import { Fragment } from 'react'

import modalService from '@/service/modal.service'

// 두 문장짜리 안내가 한 덩어리로 흐르면 사유와 할 일이 섞여 읽혀 문장마다 줄을 바꾼다(디자인 채택안).
// iOS 16.3 이하 Safari 가 lookbehind 정규식을 파싱하지 못해 split 으로 자른다
export const QrRejectSentences = ({ message }: { message: string }) => {
  const sentences = message.split('. ')
  return (
    <>
      {sentences.map((sentence, index) => (
        <Fragment key={index}>
          {index > 0 && <br />}
          {`${sentence}.`}
        </Fragment>
      ))}
    </>
  )
}

export const openQrRejectModal = ({
  message,
  actionButtonText = '다시 스캔',
  onClose,
}: {
  message: string
  actionButtonText?: string
  onClose?: () => void
}) => {
  modalService.openConfirmModal(
    {
      content: <QrRejectSentences message={message} />,
      hasCancelButton: false,
      actionButtonText,
      onClick: () => modalService.closeModal(),
    },
    {
      hasCloseButton: false,
      onClose: () => {
        onClose?.()
        return true
      },
    },
  )
}
